<template>
  <v-autocomplete
    :items="terminal_operators"
    v-model="model"
    label="Terminal Operator"
  />
</template>

<script>

export default {
  name: 'TerminalOperatorSelector',
  props: {
    model: {
      type: String,
      default: 'N/A',
      required: false,
    },
  },
  data: () => ({
    terminal_operators: [
      'VSH',
      'DP World',
    ],
  }),

};
</script>

<style scoped>

</style>
